import { Button } from '@/atoms';
import { Blok } from '@/bloks/Blok';
import { OffertaPopUpButtonStoryblok } from '@/components';
import { useOffertaModal } from '@/contexts/offerta-modal/OffertaModalProvider';
import styles from './OffertaPopUpButton.module.scss';

interface BlokProps {
	blok: OffertaPopUpButtonStoryblok;
}

const blokProps = ({ blok }: BlokProps): OffertaPopUpButtonProps => {
	const props: OffertaPopUpButtonProps = {
		buttonText: blok?.buttonText,
	};

	return props;
};

export interface OffertaPopUpButtonProps {
	buttonText: string;
	onClick?: () => void;
}

export const OffertaPopUpButton: Blok<OffertaPopUpButtonProps, BlokProps> = ({ buttonText, onClick }) => {
	const { setShowModal } = useOffertaModal();

	return (
		<Button
			className={styles.offertaButton}
			onClick={() => {
				onClick && onClick();
				setShowModal(true);
			}}
		>
			{buttonText}
		</Button>
	);
};

OffertaPopUpButton.blokProps = blokProps;
